import api from '../../api'
import type {
  CourtRentalAvailabilityDetail,
  CourtRentalAvailabilitySummary,
  CourtRentalDetail,
  CourtRentalPriceQuote,
  CourtRentalPriceQuoteRequest,
  CourtRentalReserveRequest,
  CourtRentalReserveResponse,
  CourtRentalUpcomingRow,
} from '../../../types/CourtRental'

// Plan 05-05 (frontend) consumes the two anon-readable endpoints shipped in plan 05-02:
//   GET /api/court-rentals/availability/                       — list summary
//   GET /api/court-rentals/availability/<uuid:venue_id>/?date= — venue matrix
// Reserve endpoint (POST /api/court-rentals/) ships in plan 05-06; the typed
// wrapper is included here so the API surface is complete for downstream callers.

export const getCourtRentalAvailability = async (
  date: string,
): Promise<CourtRentalAvailabilitySummary[]> => {
  const res = await api.get('court-rentals/availability/', { params: { date } })
  return res.data
}

export const getVenueCourtMatrix = async (
  venueId: string,
  date: string,
): Promise<CourtRentalAvailabilityDetail> => {
  const res = await api.get(`court-rentals/availability/${venueId}/`, { params: { date } })
  return res.data
}

export const reserveCourt = async (
  body: CourtRentalReserveRequest,
): Promise<CourtRentalReserveResponse> => {
  const res = await api.post('court-rentals/reserve/', body)
  return res.data
}

// Plan 05-06 — detail / price-quote / upcoming endpoints.

export const getCourtRental = async (
  id: string,
): Promise<CourtRentalDetail> => {
  const res = await api.get(`court-rentals/${id}/`)
  return res.data
}

export const getCourtRentalPriceQuote = async (
  params: CourtRentalPriceQuoteRequest,
): Promise<CourtRentalPriceQuote> => {
  const res = await api.get('court-rentals/price/', { params })
  return res.data
}

export const getUpcoming = async (): Promise<CourtRentalUpcomingRow[]> => {
  const res = await api.get('court-rentals/upcoming/')
  return res.data
}
